import { dispatcher } from 'dispatcher';
import { storageService } from 'js/services/storage.service';

const PROMOCODE_LOCAL_STORAGE_NAME = 'promocode';

export const savePromoCodeToStore = (promoCode) => {
    if (promoCode) {
        dispatcher.dispatch('storage:change:promoCode', promoCode);
        storageService.local.setItem(PROMOCODE_LOCAL_STORAGE_NAME, promoCode);
    }
};

export const clearUsedPromoCodeFromStore = (promoCode) => {
    const storedPromocode = storageService.local.getItem(PROMOCODE_LOCAL_STORAGE_NAME);

    if (promoCode && storedPromocode && promoCode === storedPromocode) {
        clearPromoCodeFromStore();
    }
};

export const clearPromoCodeFromStore = () => {
    storageService.local.removeItem(PROMOCODE_LOCAL_STORAGE_NAME);
    dispatcher.dispatch('storage:change:promoCode', null);
};

export const getPromoCodeFromStore = () => storageService.local.getItem(PROMOCODE_LOCAL_STORAGE_NAME);
